// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperImages-cls1_HvD","cls2":"PaperImages-cls2_Nq- PaperImages-cls1_HvD","variant-dense":"PaperImages-variant-dense_L73"};